<template>
  <b-modal ref="edit-document-modal" :title="'Modifier le document '" hide-footer >
    <div class="container-fluid my-3">

      <b-form>

        <b-form-group
          label="Code du document"
        >
          <b-form-input
            type="text"
            v-model="newCode"
            placeholder="87654321"
            :state="documentIdIsValid"
          />
          <b-form-invalid-feedback id="input-live-feedback">
            {{ errorMessage}}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form>


      <b-form-group
        label="Boucle logistique:"
        style="width: 100%"
      >
        <b-form-radio-group
          v-model="newLoop"
          :options="loopsList"
          button-variant="outline-secondary"
          buttons
        ></b-form-radio-group>
      </b-form-group>

        <div class="row justify-content-center mt-4">
          <b-button
            variant="outline-danger"
            @click="cancel()"
            class="mr-5"
            >Annuler</b-button
          >
          <b-button
            variant="primary"
            @click="editDocument"
            >
            Valider
          </b-button>
        </div>
      </div>
  </b-modal>
</template>
<script>
import server from '../api/server.vue'

export default {
  name: 'edit-document-modal',
  props: [],
  data() {
    return {
      currentLoop: '',
      newLoop: '',
      currentCode: '',
      newCode: '',
      loopsList: [],
      documentIdIsValid: true,
      errorMessage: '',
    }
  },
  methods: {
    editCode () {
      if (this.currentCode === this.newCode) {
        return Promise.resolve()
      }
      const params = { code: this.newCode}
      return server.updateDocument(this.currentCode, params).then((result) => {
      }).catch((err) => {
        this.$toasted.error(`Erreur lors du changement de code`)
      })

    },
    editLoop () {
      if (this.currentLoop === this.newLoop) {
        return Promise.resolve()
      }
      const params = { code: this.newCode, workstation: 'Emballage', loop: this.newLoop, switch_loop: true }
      return server.scanDocument(params).then((result) => {
      }).catch((err) => {
        this.$toasted.error(`Erreur lors du changement de boucle`)
      })
    },
    editDocument () {
      this.editCode().then((res) => {
        this.editLoop()
        const params = {
          oldCode: this.currentCode,
          newCode: this.newCode,
          oldLoop: this.currentLoop,
          newLoop: this.newLoop,
          oldWorkstation: this.oldWorkstation,
        }
        this.$emit('edit-document-modal-close', params)
        this.hideModal()

      })
    },
    resetData () {
      this.currentLoop = ''
      this.newLoop = ''
      this.currentCode = ''
      this.newCode = ''
      this.errorMessage = ''
      this.currentCodeGEX = ''
    },
    hideModal () {
      this.resetData()
      this.$refs['edit-document-modal'].hide()
    },
    getAllLoops() {
      return server.getLoops().then((result) => {
        this.loopsList = []
        result.data.forEach(element => {
          var item = {
                'value': element.name,
                'text':  element.description
                }
          this.loopsList.push(item)
        });
      })
    },
    showModal (document) {
      this.currentLoop = document.flux
      this.newLoop = document.flux
      this.currentCode = document.code
      this.newCode = document.code
      this.currentCodeGEX = document.code_gex
      this.oldWorkstation = document.workstation
      this.getAllLoops().then((res) => {
        this.$refs['edit-document-modal'].show()
      })
    },
    cancel () {
      this.$emit('cancel-modal', this.currentCode)
      this.hideModal()
    },
  },
  watch: {
    newCode (after, before) {
      var re = new RegExp("^8[0-9]{7}$")
      if (re.test(after) && after !== this.currentCode) {
        server.getDocumentTracking(after).then((result) => {
          this.documentIdIsValid = false
          this.errorMessage = 'Un document utilise déjà ce code'
        }).catch((error) => {
          if (error.response.status == 404) {
            this.documentIdIsValid = true
          }
        })
      } else {
        this.documentIdIsValid = re.test(after)
        this.errorMessage = 'Le code doit contenir 8 chiffres et commencer par un 8'
      }
    }
  }
}
</script>

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/components/EditDocumentModal.vue